import { render, staticRenderFns } from "./EffectivateBilling.vue?vue&type=template&id=dcb8bf64"
import script from "./EffectivateBilling.vue?vue&type=script&lang=ts"
export * from "./EffectivateBilling.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports